import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const getEditSourceCounts = {
  name: "getEditSourceCounts" as const,
  input: z.object({
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({
    counts: z.array(z.object({ source: z.string(), count: z.number() })),
  }),
};
